import TechnologyChangesType from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologyChangesType";

import type { TechnologySignalEventDto } from "../../../types/signals";

export const getTechnologySignalEventActionText = (signal: TechnologySignalEventDto): string => {
    const { changeType } = signal;

    switch (changeType) {
        case TechnologyChangesType.RenewalComingUp:
            return "has a potential renewal with";
        case TechnologyChangesType.Removed:
            return "removed";
        default:
            return "installed";
    }
};

export const getTechnologySignalEventText = (signal: TechnologySignalEventDto, companyName: string): string => {
    return `${companyName} ${getTechnologySignalEventActionText(signal)}`;
};
